module.exports = __webpack_public_path__ + "img/kommune-1505.e880bad5.svg";